import { makeStyles } from '@material-ui/core/styles';
import { DividerProps } from '@material-ui/core/Divider';

const useStyles = makeStyles({
  root: {
    margin: (props: DividerProps) => {
      const { orientation, variant } = props;
      let margin;

      if (orientation === 'horizontal') {
        margin = '6px auto';
      } else if (orientation === 'vertical') {
        margin = '-8px 4px';
      }

      if (orientation === 'horizontal' && variant === 'middle') {
        margin = '6px 16px';
      }

      return margin;
    },
    width: (props: DividerProps) => {
      const { orientation } = props;
      let width = '';
      if (orientation === 'horizontal') {
        width = 'auto';
      }
      return width;
    },
    height: (props: DividerProps) => {
      const { orientation } = props;
      let height = '';
      if (orientation === 'vertical') {
        height = 'auto';
      }
      return height;
    }
  }
});

export default useStyles;
